import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import type { ReportPeriod, ReportsResponse } from 'utils/reportMetrics'

const API_BASE = baseUrl || 'https://grobotic.app:2096'

interface UseReportsParams {
  period?: ReportPeriod
  startDate?: string
  endDate?: string
  orgId?: string
}

async function fetchReports(params: UseReportsParams): Promise<ReportsResponse> {
  const query = new URLSearchParams()
  if (params.period) query.set('period', params.period)
  if (params.startDate) query.set('startDate', params.startDate)
  if (params.endDate) query.set('endDate', params.endDate)
  if (params.orgId) query.set('orgId', params.orgId)

  const url = `${API_BASE}/search/reports?${query.toString()}`
  const { data } = await axios.get<ReportsResponse>(url)
  return data
}

export function useReportsData(params: UseReportsParams = {}) {
  const { period = 'current_month', startDate, endDate, orgId } = params

  return useQuery({
    queryKey: ['reports', period, startDate, endDate, orgId],
    queryFn: () => fetchReports({ period, startDate, endDate, orgId }),
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  })
}
